export default __webpack_public_path__ + "static/media/farmer.74c6e60e.svg";